import { useEffect, useState } from "react";
import axios from "axios";
import { Eye, Users, TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Chiffre = ({ icone: Icone, valeur, libelle, testid }) => (
  <div className="rounded-2xl border-2 border-[#E5DFD5] bg-white px-4 py-3" data-testid={testid}>
    <Icone size={15} className="text-[#E05638]" />
    <p className="font-heading mt-2 text-2xl font-bold leading-none text-stone-900">{valeur}</p>
    <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-stone-500">{libelle}</p>
  </div>
);

/** « Combien de personnes ont regardé mon numéro cette semaine ? » */
export const NumerosVus = ({ profileId }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/profiles/${profileId}/consultations-numeros`, { params: { jours: 7 } })
      .then((r) => setStats(r.data))
      .catch(() => {});
  }, [profileId]);

  if (!stats) return <p className="text-sm text-stone-400">Chargement…</p>;

  const maxi = Math.max(...stats.serie.map((j) => j.vues), 1);

  return (
    <div data-testid="numeros-vus">
      <p className="text-sm text-stone-600">
        Nombre de membres abonnés qui ont ouvert votre numéro depuis vos annonces.
      </p>

      <div className="mt-4 grid grid-cols-3 gap-3">
        <Chiffre icone={Eye} testid="numeros-vus-semaine" valeur={stats.vues_periode}
                 libelle="Cette semaine" />
        <Chiffre icone={Users} testid="numeros-vus-membres" valeur={stats.membres_distincts}
                 libelle="Membres différents" />
        <Chiffre icone={TrendingUp} testid="numeros-vus-total" valeur={stats.vues_total}
                 libelle="Depuis le début" />
      </div>

      <div className="mt-5 flex h-24 items-end gap-1.5" data-testid="numeros-vus-graphique">
        {stats.serie.map((jour) => (
          <div key={jour.date} className="group flex flex-1 flex-col items-center gap-1.5">
            <span className="text-[10px] font-bold text-stone-400 opacity-0 transition-opacity group-hover:opacity-100">
              {jour.vues}
            </span>
            <div
              className="w-full rounded-t-md bg-[#E05638] transition-all group-hover:bg-stone-900"
              style={{ height: `${Math.max((jour.vues / maxi) * 64, 3)}px` }}
            />
            <span className="text-[10px] font-semibold text-stone-400">
              {new Date(jour.date).toLocaleDateString("fr-FR", { weekday: "narrow" })}
            </span>
          </div>
        ))}
      </div>

      {stats.vues_periode === 0 && (
        <p className="mt-4 text-xs text-stone-500" data-testid="numeros-vus-conseil">
          Personne n'a encore ouvert votre numéro cette semaine. Ajoutez des photos récentes et
          gardez votre annonce active : les membres contactent d'abord les profils vérifiés.
        </p>
      )}
    </div>
  );
};
